import * as React from 'react'
import { MenuListProps, components } from 'react-select'
import { TUpdateOption } from '../update-type-select.types'

export const MenuList = (props: MenuListProps<TUpdateOption, true>) => (
  <components.MenuList {...props} className="py-0 max-h-[250px]" />
)
